import { isInApp } from "@/utils/util";
import { useState } from "react";
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect";

export default function useInApp() {
	const [isApp, setIsApp] = useState(false);

	useIsomorphicLayoutEffect(() => {
		if (process.env.NODE_ENV === "development") {
			setIsApp(true);
			return;
		}
		setIsApp(isInApp());
	}, []);
	return isApp;
}
